
import * as OM from '@/Model';
import * as Const from '@/const';
import * as VM from '@/viewModel';
import { mixins, Options, Vue } from 'vue-class-component';
import WithModel from '@/mixins/withModel';
import { Prop } from 'vue-property-decorator';

@Options({})
export default class datoAggiuntivo extends mixins(WithModel) {

    @Prop() config: OM.BaseField;
    @Prop({
        default: false
    }) readonly: boolean;

    model = OM

    get internalModel(): string | string[] {
        const value = this.localValue[this.config.identifier]
        if (this.config.type === OM.FieldType.Checkbox) {
            return value || []
        }
        return value?.[0] ?? ''
    }

    set internalModel(newValue: string | string[]) {
        if (this.config.type === OM.FieldType.Checkbox) {
            this.localValue[this.config.identifier] = newValue as string[]
        } else {
            this.localValue[this.config.identifier] = [newValue.toString()]
        }

        this.emitModel(this.localValue)
    }
}
